import { ProcessHowOftenResultDao, TaskTypeDao } from '@rock/db-admin';
import type { ConsiderationTypeId, ProcessHowOftenResult, TaskTypeId } from '@rock/types';
import { shallowEqual } from '@rock/util';
import { atom } from 'jotai';
import { atomFamily } from 'jotai/utils';

const taskTypeDao = new TaskTypeDao();
const processHowOftenResultDao = new ProcessHowOftenResultDao();

export const taskTypesState = taskTypeDao.taskTypesAtom();

export const taskTypeState = atomFamily(
    (typeId: TaskTypeId | undefined) => taskTypeDao.taskTypeAtom(typeId),
    shallowEqual,
);

export const taskTypesForConsiderationTypeState = atomFamily(
    (considerationTypeId: ConsiderationTypeId | undefined) =>
        taskTypeDao.taskTypesForConsiderationTypeAtom(considerationTypeId),
    shallowEqual,
);

export const processHowOftenResultsState = atomFamily(
    (typeId: TaskTypeId | undefined) => processHowOftenResultDao.processHowOftenResultsForTaskTypeAtom(typeId),
    shallowEqual,
);

const allProcessHowOftenResultsState = processHowOftenResultDao.processHowOftenResultsAtom();

/** Each task type's latest process how often result, by type id. */
export const latestProcessHowOftenResultsState = atom(async (get) => {
    const latest: Partial<Record<TaskTypeId, ProcessHowOftenResult>> = {};
    for (const result of await get(allProcessHowOftenResultsState)) latest[result.taskTypeId] ??= result;
    return latest;
});
